import { get } from 'lodash'

/**
 * Maps a ConfigurationDto returned by apiv2/configuration/organization/list
 * to the legacy (v1) configuration-value shape.
 */
const transformData = (item = {}) => {
  return {
    id: get(item, 'value.id'),
    organization: {
      id: get(item, 'organizationId')
    },
    configurationKey: {
      id: get(item, 'key.id'),
      keyName: {
        value: get(item, 'key.name.type'),
        translationText: get(item, 'key.name.value'),
      },
      keyGroup: {
        value: get(item, 'key.group.type'),
        translationText: get(item, 'key.group.value'),
      },
      keySubGroup: get(item, 'key.subGroup'),
      categoryType: get(item, 'key.category'),
      keyOrder: get(item, 'key.order'),
      valueType: get(item, 'key.type.type'),
      maxNumberOfValues: get(item, 'key.maxNumberOfValues'),
      readablePublic: get(item, 'key.isPublic'),
      translatedDescription: get(item, 'description'),
      description: get(item, 'description'),
    },
    valueOrder: get(item, 'value.valueOrder'),
    textValue: get(item, 'value.textValue'),
    translationKey: get(item, 'value.translationKey'),
    defaultTranslationKey: get(item, 'value.defaultTranslationKey'),
    translatedText: get(item, 'value.translatedText'),
    decimalValue: get(item, 'value.decimalValue'),
    intValue: get(item, 'value.intValue'),
    booleanValue: get(item, 'value.booleanValue'),
    fileUrl: get(item, 'value.fileUrl'),
    codeListValue: {
      id: get(item, 'value.codeListValueId'),
    },
  }
}

export default function(data = {}) {
  if (Array.isArray(data)) {
    return data.map(transformData)
  } else if (typeof data === 'object' && Object.keys(data).length > 0) {
    return transformData(data)
  }
  return []
}
